import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const CheckEmailPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "your email";

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}></div>
        <h2>Check your email</h2>
        <p style={{ marginBottom: 8 }}>
          We sent a verification link to:
        </p>
        <p style={{ fontWeight: 700, color: "#667eea", marginBottom: 24 }}>
          {email}
        </p>
        <p className="muted" style={{ marginBottom: 24 }}>
          Click the link in the email to verify your account and get started.
          If you don't see it, check your spam folder.
        </p>
        <Link to="/login" style={{ color: "#667eea", fontSize: 14 }}>
          Back to Sign in
        </Link>
      </div>
    </div>
  );
};
export default CheckEmailPage;
